import { useEffect, useState } from 'react';
import type { Profile } from '../types/profile';

const STORAGE_KEY = 'personagrama_help_profile';
const PROFILES: Profile[] = ['student', 'mentor', 'owner'];

function readStoredProfile(): Profile | undefined {
  if (typeof window === 'undefined') return undefined;
  const value = window.localStorage.getItem(STORAGE_KEY);
  return PROFILES.includes(value as Profile) ? (value as Profile) : undefined;
}

export function useProfilePreference() {
  const [profile, setProfileState] = useState<Profile | undefined>(() => readStoredProfile());

  useEffect(() => {
    const stored = readStoredProfile();
    if (stored) setProfileState(stored);
  }, []);

  function setProfile(next: Profile) {
    window.localStorage.setItem(STORAGE_KEY, next);
    setProfileState(next);
  }

  return { profile, setProfile };
}
